import { put, call, takeEvery } from 'redux-saga/effects';
import { axiosInstance, apiURL } from 'config';
import toast from 'react-hot-toast';

import {
  storeTimeSlotRequested,
  storeTimeSlotSuccess,
  storeTimeSlotFail,
  loadOrderSettingRequested,
  loadOrderSettingSuccess,
  loadOrderSettingFail,
} from './settingSlice';

export function* storeTimeSlotEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/order-setting`,
      action.payload
    );
    if (data?.succeeded) {
      yield put(storeTimeSlotSuccess(data));
      yield call(loadOrderSettingsEffect, {
        payload: {},
        type: '',
      });
      toast.success(data?.result);
    } else {
      toast.error(data?.errors);
    }
  } catch (error: any) {
    yield put(storeTimeSlotFail(error.message));
  }
}

export function* loadOrderSettingsEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/get-order-setting`
    );
    yield put(loadOrderSettingSuccess(data));
  } catch (error: any) {
    yield put(loadOrderSettingFail(error.message));
  }
}

export function* settingSaga(): Generator<any, void, any> {
  yield takeEvery(storeTimeSlotRequested, storeTimeSlotEffect);
  yield takeEvery(loadOrderSettingRequested, loadOrderSettingsEffect);
}
